import { render, staticRenderFns } from "./AwardFloat.vue?vue&type=template&id=5f58ae5a&scoped=true&"
import script from "./AwardFloat.vue?vue&type=script&lang=js&"
export * from "./AwardFloat.vue?vue&type=script&lang=js&"
import style0 from "./AwardFloat.vue?vue&type=style&index=0&id=5f58ae5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f58ae5a",
  null
  
)

component.options.__file = "AwardFloat.vue"
export default component.exports